import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const InterviewMessageSchema = z.object({
  message: z.string().min(1).max(10000),
  clientTurnId: z.string().min(1).max(100).optional(),
});

export class InterviewMessageDto extends createZodDto(InterviewMessageSchema) {}
